import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "smlouvaFull",
  nazevKey: "popis",
  kodKey: "cislo"
});
